import { OUTFIT_TYPES } from '../../config.js';

export function getOutfitNamespace(outfitType) {
    switch(outfitType) {
        case OUTFIT_TYPES.FEATURED:
            return 'featuredOutfits';            
        case OUTFIT_TYPES.GENERATED:
            return 'generatedOutfits';
        case OUTFIT_TYPES.SAVED:
            return 'savedOutfits';
    }

    return;
}
